import '../uploader.js';

export class Form {
    constructor() {
        this.form = document.querySelector('#form-specialpage');
        this.submitButton = document.querySelector('button[type=submit]');
        this.submitRequest = new Request('POST', this.form.getAttribute('action'));

        this.radios = document.querySelectorAll('.form-group input[type=radio]');
        this.textareas = document.querySelectorAll('textarea');
        this.ranges = document.querySelectorAll('.form-group input[type=range]');
        this.selects = document.querySelectorAll('select');

        this.init();
    };

    init() {

        if (this.selects) {
            this.selects.forEach(element => {
                OVS.app.helper.singleSelect(element);
            });
        }

        if(this.textareas) {
            this.textareas.forEach(element => {
                let style = getComputedStyle(element);
                element.style.height = (Math.floor(style.lineHeight.replace("px","")) * Math.floor(element.rows)) + 15 + 'px';
            });
        }

        if(this.radios) {
            this.radios.forEach(element => {
                let label = document.querySelector('label[for="'+element.id+'"]');
                label.innerHTML = label.innerHTML.replace('*', '');
            });
        }

        if(this.ranges) {
            this.ranges.forEach(element => {
                element.addEventListener('change', () => {
                    let val = element.value;
                    if (val < 0) {
                        val = 0;
                    }
                    let widthClass = 'w' + (val * 10);
                    element.className = '';
                    element.classList.add('form-control');
                    element.classList.add(widthClass);
                });
            });
        }

        if (this.submitButton) {
            this.submitButton.addEventListener('click', () => {
                let requriedInputs = document.querySelectorAll('[data-required="1"]');
                if (requriedInputs) {
                    requriedInputs.forEach(input => {
                        input.setAttribute('required', true);
                    });
                }
                let hiddenInputs = document.querySelectorAll('input[required], select[required], textarea[required]');
                if (hiddenInputs) {
                    hiddenInputs.forEach(input => {
                        if (input.classList.contains('hiddenfileupload')) {
                            return;
                        }
                        if (!OVS.app.helper.isVisible(input)) {
                            input.setAttribute('data-ignore', 1);
                            input.setAttribute('data-required', 1);
                            input.removeAttribute('required');
                        } else {
                            input.removeAttribute('data-ignore', 1);
                        }
                    });
                }
            });
        }

        this.form.addEventListener('submit', event => {
            event.preventDefault();
            this.submitRequest.formData = this.form;
            this.submitRequest.call(response => {
                if(response.status == 'ok') {
                    Tracking.customEvent('checkout_lead', {
                        form_fields: this.getFormFieldNames(),
                        event_category: "checkout",
                        event_action: "lead",
                        event_label: document.title,
                    });

                    OVS.app.helper.toggleButton(true);
                    window.location.replace(response.redirect);
                } else if(response.status == 'validation') {
                    this.resetValidation();
                    response.fields.forEach(value => {
                        let element = document.querySelector('.form-error-' + value);
                        let label = document.querySelector('label[name="'+value+'"]');
                        if(!label) {
                            label = document.querySelector('label[for="'+value+'"]');
                        }
                        if(element) {
                            element.classList.remove('d-none');
                        }
                        if(label) {
                            label.classList.add('text-danger');
                        }
                    });
                    OVS.app.helper.scrollTo('.form-error-' + response.fields[0], true, 0);
                }
            });
        });
    };

    resetValidation() {
        let errors = document.querySelectorAll('.form-error');
        let labels = document.querySelectorAll('label');

        if(errors) {
            errors.forEach(element => {
                element.classList.add('d-none');
            });
        }

        if(labels) {
            labels.forEach(element => {
                element.classList.remove('text-danger');
            });
        }
    };

    getFormFieldNames() {
        //let names = Array.from(this.form.elements).map(e => e.name);
        let names = Array.from(this.form.elements).map((element) => {
            if (element.type != 'hidden') {
                return element.name;
            }
        });

        return names.filter(element => element) ?? [];
    }
};
